import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ModuleService } from "services/module.service";
import { IModule } from "models/ModuleModel";
import { WorkflowService } from "services/WorkFlow/workflow.service";
import { Shared } from "utility/shared";
import { RootState } from "./store";
import { IWorkflowStatus } from "models/WorkFlow/WorkflowStatusModel";
import { IWorkflowType } from "models/WorkFlow/WorkflowTypeModel";

export interface WorkFlowState {
	workflowStatusList: IWorkflowStatus[];
	workflowTypeList: IWorkflowType[];
	moduleList: IModule[];
}

const initialState: WorkFlowState = {
	workflowStatusList: [],
	workflowTypeList: [],
	moduleList: [],
};

export const fetchWorkFlowStatusList = createAsyncThunk(
	"getWorkFlowStatusList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.workflowState.workflowStatusList.length === 0) {
			return await WorkflowService.getWorkFlowStatusList();
		}
	}
);

export const fetchWorkFlowTypeList = createAsyncThunk(
	"getWorkFlowTypeList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.workflowState.workflowTypeList.length === 0) {
			return await WorkflowService.getWorkFlowTypeList();
		}
	}
);

export const fetchModuleList = createAsyncThunk(
	"getModuleList",
	async (_args, { getState }) => {
		const state = getState() as RootState;
		if (state.workflowState.moduleList.length === 0) {
			return await ModuleService.getModuleList();
		}
	}
);

export const workflowStateSlice = createSlice({
	name: "WorkFlowState",
	initialState,
	reducers: {},
	extraReducers: {
		[fetchWorkFlowStatusList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.workflowStatusList = action.payload;
			}
		},
		[fetchWorkFlowStatusList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading workflow status list, please try again!"
			);
		},
		[fetchWorkFlowTypeList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.workflowTypeList = action.payload;
			}
		},
		[fetchWorkFlowTypeList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading workflow type list, please try again!"
			);
		},
		[fetchModuleList.fulfilled.type]: (state, action) => {
			if (action.payload && action.payload.length > 0) {
				state.moduleList = action.payload;
			}
		},
		[fetchModuleList.rejected.type]: (_state, _action) => {
			Shared.showSnackbarMessage(
				"Error loading module list, please try again!"
			);
		},
	},
});

export default workflowStateSlice.reducer;
